import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';

export async function create_purchase_bill(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-bill/create-purchase-bill`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
}

export async function updatePurchaseBill(body) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-bill/update-purchase-bill`,
			body,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
}

export const fetchPurchaseBill = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/purchase-bill/get-purchase-bill`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const getPurchaseBills = async (params) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/bills/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const getPurchaseBillDetails = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/purchase/bills/details/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const fetchPurchaseBillDetails = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(
			`${APP_API_URL}/purchase-bill/get-purchase-bill/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const fetchPurchaseBillByVendorId = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(
			`${APP_API_URL}/purchase-bill/get-purchase-bill-by-vendor/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const deletePurchaseBill = async (purchase_bill_ids) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.post(
			`${APP_API_URL}/purchase-bill/delete-purchase-bill`,
			{ purchase_bill_ids },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export const undoPurchaseReceive = async (purchase_bill_id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.delete(
			`${APP_API_URL}/purchase-bill/undo-receive/${purchase_bill_id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw new Error(error?.response.data.message);
	}
};

export async function generatePurchaseBillsPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/purchase/bills/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
